import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import LegalLayout from '../layouts/LegalLayout';

const LegalPage = ({ fileName }) => {
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    // Markdown files are in the public/legal-docs directory
    fetch(`/legal-docs/${fileName}`)
      .then((response) => response.text())
      .then((text) => setMarkdown(text));
  }, [fileName]);

  return (
    <LegalLayout>
      <ReactMarkdown>{markdown}</ReactMarkdown>
    </LegalLayout>
  );
};

export default LegalPage;